import ApplianceService from "../ApplianceService"
import AttachmentEntity from "@/NewModel/Attachment/Entity/AttachmentEntity"

const
    FETCHING_RECORDS = "FETCHING_RECORDS",
    FETCHING_RECORDS_SUCCESS = "FETCHING_RECORDS_SUCCESS",
    FETCHING_RECORDS_ERROR = "FETCHING_RECORDS_ERROR",
    CREATING_RECORD = "CREATING_RECORD",
    CREATING_RECORD_SUCCESS = "CREATING_RECORD_SUCCESS",
    CREATING_RECORD_ERROR = "CREATING_RECORD_ERROR",
    DELETING_RECORD = "DELETING_RECORD",
    DELETING_RECORD_SUCCESS = "DELETING_RECORD_SUCCESS",
    DELETING_RECORD_ERROR = "DELETING_RECORD_ERROR",
    CLEAR_RECORDS = "CLEAR_RECORDS"

const initialState = {
    isLoading: false,
    isCreating: false,
    isDeleting: false,
    records: [],
    totalRecords: 0,
    error: null,
}

export const state = {...initialState}

export const actions = {

    /**
     * @param commit
     * @param id : Number
     * @returns {Promise<[]>}
     */
    async findAttachments({commit}, id) {
        try {
            commit(FETCHING_RECORDS)
            let response = await ApplianceService.getApplianceAttachments(id)
            commit(FETCHING_RECORDS_SUCCESS, response.data)
            return state.records
        } catch (error) {
            commit(FETCHING_RECORDS_ERROR, error)
            return Promise.reject(error)
        }
    },

    /**
     * @param commit
     * @param id : Number
     * @param attachments : Array
     * @returns {Promise<*>}
     */
    async addAttachments({commit}, {id, attachments}) {

        try {
            commit(CREATING_RECORD)
            let response = await ApplianceService.addApplianceAttachment(id, attachments)
            commit(CREATING_RECORD_SUCCESS, response.data)
            return response.data
        } catch (error) {
            commit(CREATING_RECORD_ERROR, error)
            return Promise.reject(error)
        }
    },

    /**
     * @param commit
     * @param appliance : Number
     * @param attachment : String
     * @returns {Promise<*>}
     */
    async deleteAttachment({commit}, {appliance, attachment}) {
        try {
            commit(DELETING_RECORD)
            let response = await ApplianceService.deleteApplianceAttachment(appliance, attachment)
            commit(DELETING_RECORD_SUCCESS, response.data)
            return response.data
        } catch (error) {
            commit(DELETING_RECORD_ERROR, error)
            return Promise.reject(error)
        }
    },

    async clearAll({commit}) {
        commit(CLEAR_RECORDS)
    },

}

export const mutations = {

    [FETCHING_RECORDS](state) {
        state.isLoading = true
        state.error = null
        state.records = []
        state.totalRecords = 0
    },
    [FETCHING_RECORDS_SUCCESS](state, records) {
        state.isLoading = false
        state.records = records.map(record => AttachmentEntity.from(record))
        state.totalRecords = records.length
    },
    [FETCHING_RECORDS_ERROR](state, error) {
        state.isLoading = false
        state.error = error
        state.records = []
        state.totalRecords = 0
    },

    [CREATING_RECORD](state) {
        state.isCreating = true
        state.error = null
    },
    [CREATING_RECORD_SUCCESS](state, records) {
        state.isCreating = false
        state.error = null
        state.records.unshift(...records.map(record => AttachmentEntity.from(record)))
        state.totalRecords = state.totalRecords + records.length
    },
    [CREATING_RECORD_ERROR](state, error) {
        state.isCreating = false
        state.error = error
    },

    [DELETING_RECORD](state) {
        state.isDeleting = true
        state.error = null
    },
    [DELETING_RECORD_SUCCESS](state) {
        state.isDeleting = false
        state.error = null
    },
    [DELETING_RECORD_ERROR](state, error) {
        state.isDeleting = false
        state.error = error
    },

    [CLEAR_RECORDS](state) {
        state.isLoading = false
        state.error = null
        state.records = []
        state.totalRecords = 0
    }

}

export const getters = {

    isLoading(state) {
        return state.isLoading
    },

    isCreating(state) {
        return state.isCreating
    },

    isDeleting(state) {
        return state.isDeleting
    },

    hasError(state) {
        return state.error !== null
    },

    error(state) {
        return state.error
    },

    hasAttachments(state) {
        return state.records.length > 0
    },

    getAttachments(state) {
        return state.records
    },

    getTotalAttachments(state) {
        return state.totalRecords
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
